import Joi from "joi";
import { customMessages } from "./messages";

function ValidateCustomerProperties(customerProperty) {
  const schema = Joi.object({
    nome: Joi.string().min(3).max(100).required().messages(customMessages.nome),
    cidade: Joi.string().min(3).max(100).required().messages(customMessages.cidade),
    uf: Joi.string().min(2).max(2).required().messages(customMessages.uf),
    cep: Joi.string().min(8).max(9).required().messages(customMessages.cep),
  }).unknown(true)

  const { error } = schema.validate(customerProperty, { abortEarly: false })
 
  if(error?.details && error?.details.length) {
    const errors = error?.details.map(erro => {
      if (erro?.message || erro?.path[0]) {
        if(erro.path.length > 1) {
          return {
            message: erro?.message,
            keyError: erro?.path[1],
            type: erro.type.split('.')[1]
          }
        }
        
        return {
          message: erro?.message,
          keyError: erro?.path[0],
          type: erro.type.split('.')[1]
        }
      }
    })

    console.log(errors)

    return errors
  }
}

export { ValidateCustomerProperties }